<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="justify-center mt-3">
                <v-col cols="3">
                    <v-autocomplete
                    v-model="content.turma"
                    label="Turma"
                    dense
                    outlined
                    item-text="nome"
                    item-value="turmaId"
                    :items="turmas"
                    return-object
                    :disabled="camposDesabilitados"
                    @change="onTurmaChage"
                    />
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="Data"
                        v-model="content.dataRealizacao"
                        outlined
                        dense
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="Turno"
                        v-model="content.nomeTurno"
                        outlined
                        dense
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                        label="Hora"
                        v-model="content.hora"
                        outlined
                        dense
                        maxLength="5"
                        @keypress="$validarEntradaNumerica"
                        @input="formatarHoraInput('hora', $event)"
                        :rules="[
                          (h) => horaValida(h),
                          (h) => validarFormatoHora(h) || 'O horário deve ser no formato HH:MM',
                          ]"
                        :disabled="camposDesabilitados"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="Atividade"
                        v-model="content.atividade"
                        outlined
                        dense
                        maxlength="200"
                        :disabled="camposDesabilitados"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="content.instrutor"
                        label="Instrutores"
                        dense
                        outlined
                        item-text="nome"
                        item-value="instrutorId"
                        :items="instrutores"
                        return-object
                        :disabled="camposDesabilitados"
                        multiple
                    />
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" @click="adicionarAtualizarProgramacao"  :disabled="!podeAdicionarProgramacao || isViewMode || situacaoEmRevisao">
                    <v-icon left>mdi-plus</v-icon> Incluir
                  </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-data-table
          class="mt-5"
          dense
          :headers="headers"
          :items="content.programacoes"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
        <template v-slot:[`item.turma`]="{ item }">
            {{ item.turma.nome }}
        </template>
        <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ item.dataRealizacao }}
        </template>
        <template v-slot:[`item.hora`]="{ item }">
            {{ formatarHora(item.hora) }}
        </template>
        <template v-slot:[`item.atividade`]="{ item }">
            {{ item.atividade }}
        </template>
        <template v-slot:[`item.instrutor`]="{ item }">
            {{ (Array.isArray(item.instrutor) ? item.instrutor : [item.instrutor]).map(instrutor => instrutor.nome).join(', ') }}
        </template>
          <template v-slot:[`item.acoes`]="{ item, index }">
            <div :key="index">
                <sigfoco-tooltip
                  :text="'Editar'"
                  :icon="'mdi-pencil'"
                  :small="true"
                  :disabled="camposDesabilitados"
                  @click="editarProgramacao(item, index)"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                  :text="'Excluir'"
                  :icon="'mdi-delete'"
                  :small="true"
                  :disabled="camposDesabilitados"
                  @click="excluirProgramacao(item, index)"
                ></sigfoco-tooltip>
            </div>
          </template>
        </v-data-table>
        <div v-if="($user.isAdmGre || $user.isAdmGeral) && qtdAjustes >= 3 && !isViewMode" class="alert-message d-flex align-center mt-4">
          <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
          <span>Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.</span>
        </div>
        <v-row class="mt-3" v-if="situacaoParaExibirComentario">
          <v-col cols="12">
            <v-textarea
              v-model="content.comentario"
              label="Comentário"
              maxlength="400"
              counter="400"
              dense
              outlined
              rows="6"
              :disabled="isViewMode || qtdAjustes >= 3 || isReenviar()"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="!isFormador">
          <v-col cols="12">
            <p><b>{{ content.ultimaAtualizacao }}</b></p>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="d-block text-center btn-group">
              <v-col cols="12">
                  <v-btn  color="primary" outlined class="ml-2" @click="voltar">
                    Voltar
                  </v-btn>
                  <v-btn v-if="!isViewMode && isFormador" color="primary" class="ml-2" @click="salvar(false)">
                      Salvar
                  </v-btn>
                  <v-btn v-if="!isViewMode && isFormador && !situacaoParaExibirComentario" color="primary" class="ml-2" @click="salvar(true)">
                      <v-icon v-if="actionIcon">{{ actionIcon }}</v-icon> {{ edit ? 'Editar e Avançar' : 'Salvar e Avançar' }}
                  </v-btn>
                  <v-btn v-if="isFormadorOrAdm && !isViewMode && situacaoParaExibirComentario" color="primary" class="ml-2" @click="solicitarCorrecao">
                    Salvar e Avançar
                  </v-btn>
                  <v-btn v-if="!isViewMode" color="primary" outlined class="ml-2" @click="cancelar">
                    {{ isReenviar() ? 'Cancelar':'Fechar' }}
                  </v-btn>
                  <v-btn v-if="isViewMode" color="primary" outlined class="ml-2" @click="avancar">
                    Avançar
                  </v-btn>
                  <v-btn v-if="(isFormadorOrAdm || isReenviar()) && !situacaoParaNaoExibirBaixar" color="primary" outlined class="ml-2" @click="baixarProgramacao">Baixar Programação</v-btn>

                  <v-btn v-if="isViewMode" color="primary" outlined class="ml-2" @click="cancelar">
                    Fechar
                  </v-btn>
              </v-col>
          </v-row>
    </div>
</template>
  
  <script>
  import { Formacao } from '~/commons/classes/formacao';
  import { DialogPropsFormacao } from '~/commons/classes/dialog-props-formacao';
  import FormacaoService from "~/services/manter-formacao.service";
  import { globalStore }from "~/mixins/global-formacao.mixin";
  import { AUTH_NAMESPACE, USER, LOGIN, ABILITIES } from 'store/modules/auth';
  export default {
    name: "AbaProgramacao",
    props: new DialogPropsFormacao(Formacao),
    mixins: [FormacaoService],
    data: () => ({
        programacaoEditandoIndex: null,
        turmas: [],
        instrutores: [],
        jaSofreuTresAjustes: false,
        qtdAjustes: 0,
        comentarioInicial: null,
        headers: [
        { text: "Turma", align: "center", value: "turma" },
        { text: "Data", align: "center", value: "dataRealizacao" },
        { text: "Hora", align: "center", value: "hora" },
        { text: "Atividade", align: "center", value: "atividade" },
        { text: "Instrutor", align: "center", value: "instrutor" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],


    }),
    created() {
      if (globalStore.dadosProgramacao) {
          this.preencherCampos();
      }
      this.$nextTick(() => {
        this.isViewMode = globalStore.isViewMode;
      });
    },
    computed: {
      // Expor o usuário completo do store (mesma forma usada em outras abas)
      $user() {
        const user = this.$store.getters[`${AUTH_NAMESPACE}/${USER}`];
        const permissions = this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`];
        return {
          ...user,
          permissions
        };
      },
      isFormadorOrAdm() {
        // Verifica se o usuário possui simultaneamente:
        // 1. Algum perfil que contém 'formador'
        // 2. Algum perfil que contém 'adm' ou 'administrador'
        const roles = this.$user?.roles;
        if (!Array.isArray(roles) || roles.length === 0) {
          return false;
        }

        const perfis = roles.map((perfil) =>
            typeof perfil === 'string'
                ? perfil
                : perfil?.nome || perfil?.name || perfil?.descricao || perfil?.perfil || ''
        ).filter(Boolean);

        const possuiFormador = perfis.some((p) => p.toLowerCase().includes('formador'));
        const possuiAdmin = perfis.some((p) => p.toLowerCase().includes('administrador'));

        return possuiFormador || possuiAdmin;
      },
      camposDesabilitados() {
        // Campos são desabilitados quando:
        // 1. Está em modo visualização (isViewMode)
        // 2. Usuário NÃO é formador
        // 3. Situação está em revisão (2,3,9,10)
        return this.isViewMode || !this.isFormador || this.situacaoEmRevisao;
      },
      isViewMode() {
        return globalStore.isViewMode;
      },
      situacaoEmRevisao() {
        // Forçar Number para evitar mismatch string/number
        const situacaoId = Number(globalStore.situacaoId);
        return [2, 3, 9, 10].includes(situacaoId);
      },
      situacaoParaNaoExibirBaixar() {
        return [1].includes(globalStore.situacaoId);
      },
      situacaoParaExibirComentario() {
        return [2, 3, 6, 8, 9, 10].includes(globalStore.situacaoId);
      },
      // Verifica se o usuário possui perfil relacionado a formador
      isFormador() {
        const roles = Array.isArray(this.$user?.roles) ? this.$user.roles : [];
        if (!roles.length) return false;

        return roles.some((perfil) => {
          if (typeof perfil === 'string') return perfil.toLowerCase().includes('formador');
          const perfilStr = perfil?.nome || perfil?.name || perfil?.descricao || perfil?.perfil || '';
          return String(perfilStr).toLowerCase().includes('formador');
        });
      },
        podeAdicionarProgramacao() {
        return !!(
          this.content.turma &&
            this.content.dataRealizacao &&
            this.content.nomeTurno &&
            this.content.hora &&
            this.content.atividade &&
            this.content.instrutor &&
            this.content.instrutor?.length > 0
        );
      },
      user() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
      },
    },
    methods: {
    construirPayload() {
        const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
        const { programacoes } = this.content;
        return {
            formacaoId,
            programacoes: programacoes?.map(programacao => ({
                id: programacao.id,
                turma: programacao.turma,
                dataRealizacao: programacao.dataRealizacao,
                hora: programacao.hora ? `${programacao.hora}` : null,
                atividade: programacao.atividade,
                instrutores: programacao.instrutor.map(i => ({ instrutorId: i.instrutorId }))
            })) || []
        };
    },
    salvar(fecharTela) {
        if (this.$validarFormulario("Para inserir o registro na tabela, todos os campos devem ser preenchidos.")) {
        
          if (
            !this.content.programacoes?.length
          ) {
            this.$notifyError("Por favor adicione ao menos um registro no grid de listagem!");
            return;
          }
          this.$swal({
            text: `Confirma os dados de Programação da Solicitação de Formação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            }).then(() => {
                const payload = this.construirPayload();
                return this.$cadastrarFormacaoProgramacao(payload);
            }).then(({ data }) => {
              if (!this.content.id && data.formacaoId) {
                    globalStore.setFormacaoIdCriado(data.formacaoId);
                }
                this.$notifySuccess(data.mensagem);
                this.$emit("onSave");
                if (fecharTela) {
                  this.$emit('changeTab', 2);
                }                
            });
        }
    },
    onTurmaChage(turma) {
        if (turma && turma.dataRealizacao) {
            this.content.dataRealizacao = this.formatarData(turma.dataRealizacao);
            this.content.nomeTurno = turma.turno?.descricao;
        }
    },

    formatarData(data) {
        if (!data) return "";
        const partes = data.split("T")[0].split("-");
        if (partes.length === 3) {
            const [ano, mes, dia] = partes;
            return `${dia}/${mes}/${ano}`;
        }
        return data;
    },

    editarProgramacao(item, index) {
      if (!this.content.programacoes || !item?.turma) {
        return;
      }
      this.programacaoEditandoIndex = index;
      this.$set(this.content, 'turma', this.turmas.find(t => t.turmaId === item.turma.turmaId));
      this.$set(this.content, 'dataRealizacao', item.dataRealizacao);
      this.$set(this.content, 'nomeTurno', item.nomeTurno || item.turno?.descricao);
      this.$set(this.content, 'hora', this.formatarHora(item.hora));
      this.$set(this.content, 'atividade', item.atividade);
      this.$set(this.content, 'instrutor', item.instrutor);

    },
    adicionarAtualizarProgramacao() {
        if (!this.content.turma || !this.content.dataRealizacao || !this.content.nomeTurno || !this.content.hora || !this.content.atividade || !this.content.instrutor?.length > 0) {
          this.$notifyError("Para inserir o registro na tabela, todos os campos devem ser preenchidos.");
          return;
        }
        if (!this.content.programacoes) {
          this.$set(this.content, "programacoes", []);
        }
        const turmaSelecionada = this.content.turma;
        const horaInicio = turmaSelecionada.horaInicio.slice(0, 5);
        const horaFim = turmaSelecionada.horaFim.slice(0, 5);
        const horaDigitada = this.content.hora;
        if (horaDigitada < horaInicio || horaDigitada > horaFim) {
            this.$notifyError("O horário selecionado para esta atividade não corresponde ao horário da turma. Por favor, revise e escolha um horário válido.");
            return;
        }
        if (this.programacaoEditandoIndex !== null) {
          this.$set(this.content.programacoes, this.programacaoEditandoIndex, {
            ...this.content.programacoes[this.programacaoEditandoIndex],
            turma: this.content.turma,
            dataRealizacao: this.content.dataRealizacao,
            nomeTurno: this.content.nomeTurno,
            hora: this.content.hora ? `${this.content.hora}:00` : null,
            atividade: this.content.atividade,
            instrutor: this.content.instrutor,
          });
          this.content.programacoes = [...this.content.programacoes];
          this.programacaoEditandoIndex = null;
        } else {
            this.content.programacoes.push({
                turma: this.content.turma,
                dataRealizacao: this.content.dataRealizacao,
                nomeTurno: this.content.nomeTurno,
                hora: this.content.hora ? `${this.content.hora}:00` : null,
                atividade: this.content.atividade,
                instrutor: this.content.instrutor,
            });
            this.$set(this.content, "programacoes", [...this.content.programacoes]);
        }

        this.resetFormProgramacao();
        this.$forceUpdate();
    },
    avancar() {
      this.$emit('changeTab', 2);
    },
    isReenviar(){
        return globalStore.isReenviarSolicitacao;
    },
    async baixarProgramacao() {
      const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
      const isAdmGre = this.$user.isAdmGre;
      const isAdmGeral = this.$user.isAdmGeral;
      this.showPageLoading();
      try {
        const { data } = isAdmGre || isAdmGeral
          ? await this.$obterRelatorioCSVProgramacao(formacaoId, true)
          : await this.$obterRelatorioCSVProgramacao(formacaoId);

        if (isAdmGre || isAdmGeral || this.isReenviar()) {
          this.$baixarArquivo(data, `SIGFOCO.RelatórioDeProgramação.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        } else {
          this.$baixarArquivo(data, `SIGFOCO.RelatórioDeProgramação.csv`, 'text/csv;charset=utf-8;');
        }

        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },

    excluirProgramacao(programacao) {
        this.$swal({
          text: `Deseja confirmar a exclusão da Programação?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result) {
            this.content.programacoes = this.content.programacoes.filter(t => t !== programacao);
            this.$forceUpdate();
            this.$notifySuccess("Programação removida com sucesso.");
          }
        });
    },
    resetFormProgramacao() {
        this.content.turma = "";
        this.content.dataRealizacao = "";
        this.content.nomeTurno = "";
        this.content.hora = "";
        this.content.atividade = "";
        this.content.instrutor = "";
    },
    formatarHoraInput(campo, event) {
        let value = event;
        value = value.replace(/\D/g, '');

        if (value.length > 2) {
          value = value.slice(0, 2) + ':' + value.slice(2, 4);
        }

        this.content[campo] = value;
        this.$forceUpdate();
    },
    validarFormatoHora(hora) {
        if(!hora)return true;
        return /^\d{2}:\d{2}$/.test(hora);
    },
    cancelar() {
      if (
        (this.$user.isAdmGre || this.$user.isAdmGeral) &&
        this.content.comentario !== this.comentarioInicial &&
        !this.isViewMode
      ) {
        return this.fechar();
      }
      this.$emit('onClose');
      globalStore.limpar();
    },
    fechar() {
        return this.$swal({
            text: "Ao fechar sem salvar, as informações inseridas serão perdidas. Tem certeza que deseja continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => { 
            if (result) {
              this.$emit('onClose');
              globalStore.limpar();
            }
        });
      },
    voltar() {
      const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
      this.$emit('changeTab', 0, formacaoId);
    },
    preencherCampos() {
      if (!globalStore.dadosProgramacao) {
        return;
      }

      const dados = globalStore.dadosProgramacao;

      this.content.id = dados.id ?? null;
      this.content.programacoes = [];
      this.turmas = dados.lista;
      this.content.comentario = dados.lista?.length > 0 
        ? dados.lista[0].comentario ?? "" 
        : "";
        this.content.ultimaAtualizacao = this.turmas?.[0]?.utilmaAtualizacao ?? null;
      this.comentarioInicial = this.content.comentario;
      dados.lista?.forEach(turma => {
        if (turma.programacoes && turma.programacoes.length > 0) {
          turma.programacoes.forEach(programacao => {
            this.content.programacoes.push({
                id: programacao.id,
              turma: programacao.turma,
              dataRealizacao: this.formatarData(programacao.dataRealizacao),
              hora: programacao.hora,
              atividade: programacao.atividade,
              instrutor: programacao.instrutores,
              turno: programacao.turno
            });
          });
        }
      });
    },
    horaValida(h) {
        if (!h) return true;
        const [hora, minuto] = h.split(':').map(Number);

        if (isNaN(hora) || isNaN(minuto)) {
          return 'Hora inválida';
        }

        if (!/^\d{2}:\d{2}$/.test(h)) {
          return;
        }

        const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
        return condicao ? true : 'Hora inválida';
    },
    formatarHora(hora) {
        if (!hora) return "";
        const partes = hora.split(":");
        if (partes.length >= 2) {
          return `${partes[0]}:${partes[1]}`;
        }
        return hora;
    },
    solicitarCorrecao(){
      const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
      if (this.jaSofreuTresAjustes) {
        this.$emit('changeTab', 2);
        return;
      }
      this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const payload = {
                  comentario: this.content.comentario
              };
              const numeroDaAba = 2;
              return this.$solicitarCorrecao(formacaoId,numeroDaAba, payload);
          }).then(({ data }) => {
            if (!this.content.id && data.formacaoId) {
                  globalStore.setFormacaoIdCriado(data.formacaoId);
              }
              this.$notifySuccess(data.mensagem);
              this.$emit("onSave");      
              this.$emit('changeTab', 2);          
          }
        );
      },
  },
  mounted() {
    const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
    this.$visualizarAbaProgramacao(formacaoId).then(({ data }) => {
    globalStore.dadosProgramacao = { lista: data.lista };
    this.preencherCampos();
    });
    this.$visualizarAbaProgramacaoInstrutores(formacaoId).then(({ data }) => {
        this.instrutores = data.lista;
    });
    if(formacaoId && (this.$user.isAdmGre || this.$user.isAdmGeral)) {
      this.$consultarStatusLimiteDeAjustes(formacaoId).then(({ data }) => {
        this.jaSofreuTresAjustes = data.jaSofreuTresAjustes;
        this.qtdAjustes = data.qtdAjustes;
      });
    }
  console.log("isAdmGre:", this.$user.isAdmGre);
  console.log("isAdmGeral:", this.$user.isAdmGeral);
  console.log("isViewMode:", this.isViewMode);
  }
}
</script>
<style scoped>
.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
</style>